import { render, staticRenderFns } from "./PreviewUploadedFile.vue?vue&type=template&id=bb9e7872&scoped=true"
import script from "./PreviewUploadedFile.vue?vue&type=script&lang=js"
export * from "./PreviewUploadedFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9e7872",
  null
  
)

export default component.exports